"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "buccino": {
    "5455f6c9": [{
      "hkey": "8a61a065",
      "slug": "buccino",
      "name": "Buccino",
      "primary": true,
      "skipSearch": false
    }],
    "eliceto": [{
      "hkey": "8a61a065",
      "slug": "buccino",
      "name": "Buccino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b8d488c4": [{
      "hkey": "8a61a065",
      "slug": "buccino",
      "name": "Buccino",
      "primary": true,
      "skipSearch": false
    }],
    "mesarico": [{
      "hkey": "8a61a065",
      "slug": "buccino",
      "name": "Buccino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8416365c": [{
      "hkey": "a671f39b",
      "slug": "teglia",
      "name": "Teglia",
      "primary": true,
      "skipSearch": false
    }],
    "teglie": [{
      "hkey": "a671f39b",
      "slug": "teglia",
      "name": "Teglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;